import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { ThemeService } from '@egret/shared/services/theme.service';
import { RoutePartsService } from '@egret/shared/services/route-parts.service';
import { AppLoaderService } from '@egret/shared/services/app-loader/app-loader.service';

import { BookrawSharedComponentsModule } from './components/shared-components.module';
import { CustomNavigationService } from './services/navigation.service';
import { NavigationService } from '@egret/shared/services/navigation.service';
import { BookrawSharedDirectivesModule } from './directives/shared-directives.module';
import { AuthGuard } from 'bookraw/shared/services/auth-guard';
import { BookrawSharedPipesModule } from './pipes/shared-pipes.module';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from 'bookraw/shared/helpers/custom-date-adapter';
import { CustomBreakPointsProvider, CustomFlexDirective } from 'bookraw/shared/helpers/breakpoints';

@NgModule({
  imports: [
    CommonModule,
    BookrawSharedComponentsModule,
    BookrawSharedPipesModule,
    BookrawSharedDirectivesModule,
    NgxDatatableModule,
  ],
  providers: [
    ThemeService,
    // A NavigationService felül van írva, hogy ne kelljen belenyúlni az egretbe
    { provide: NavigationService, useClass: CustomNavigationService },
    RoutePartsService,
    AuthGuard,
    AppLoaderService,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    CustomBreakPointsProvider
  ],
  declarations: [
    CustomFlexDirective
  ],
  exports: [
    BookrawSharedComponentsModule,
    BookrawSharedPipesModule,
    BookrawSharedDirectivesModule,
    CustomFlexDirective
  ]
})
export class BookrawSharedModule {
}
